import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Gallery from './components/GalleryPage';
import Education from './components/About/Education';
import SocialService from './components/About/SocialService';
import Motivation from './components/About/Motivation';
import Logo from './components/About/logo'; 
import FutureScope from './components/About/FutureScope';
import Admin from './components/Admin/Admin';
import RulesAndRegulations from './components/Admission/RulesAndRegulations';
import Procedure from './components/Admission/Procedure';
import Contact from './components/Contact';
import DonationPage from './components/Donation';
import Activities from './components/Activities';
import Admission from './components/Admission/AdmissionEnquiry';
import Academics from './components/Academics';





const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/education" element={<Education />} />
        <Route path="/social-service" element={<SocialService />} />
        <Route path="/motivation" element={<Motivation />} />
        <Route path="/logo" element={<Logo />} />
        <Route path="/future-plan" element={<FutureScope />} />
        <Route path="/jniadminwork" element={<Admin />} />
        <Route path="/rules-regulations" element={<RulesAndRegulations />} />
        <Route path="/admission-procedure" element={<Procedure />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/donate" element={<DonationPage />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/admission-enquiry" element={<Admission />} />
        <Route path="/academics" element={<Academics />} />
      </Routes>
    </Router>
  );
};

export default App;
